/**
 * スライダー
 * 「.slider」に対して処理をする
 * 
 */
import { functions } from "../../modules/functions";
import Swiper, { Navigation, Pagination, Scrollbar, Thumbs, Autoplay } from 'swiper';

export module SliderModule {
  export class Service {
    constructor() {
      document.addEventListener('readCompleteAction', () => {
        Service.setEvent();
      });
    }

    public static setEvent() {
      const $sliders = document.querySelectorAll<HTMLElement>('.slider');

      if ($sliders) {
        $sliders.forEach($slider => {
          const $swiper = $slider.querySelector('.swiper:not(.slider-thumbnail)');
          const $thumbnail = $slider.querySelector('.swiper.slider-thumbnail');

          if (!$swiper?.getAttribute('id')) {
            const $id = functions.createUniqueID();
            $swiper?.setAttribute('id', $id);
          }

          if ($thumbnail && !$thumbnail?.getAttribute('id')) {
            const $id = functions.createUniqueID();
            $thumbnail?.setAttribute('id', $id);
          }

          if ($swiper) {
            const $sliderId = '#' + $swiper.getAttribute('id');

            if ($thumbnail) {
              const $sliderThumbnailId = '#' + $thumbnail.getAttribute('id');

              const $dataSlidesPerView = $thumbnail.getAttribute('data-slidesPerView');
              let $slidesPerView: number | "auto" | undefined;
              if (typeof $dataSlidesPerView === 'number') {
                $slidesPerView = parseInt($dataSlidesPerView);
              } else {
                $slidesPerView = 'auto';
              }

              const $sliderThumbnail = new Swiper($sliderThumbnailId, {
                modules: [Navigation, Pagination, Scrollbar, Thumbs],
                slidesPerView: $slidesPerView,
                freeMode: true,
                watchSlidesProgress: true,
              });

              const $slider = new Swiper($sliderId, {
                modules: [Navigation, Pagination, Scrollbar, Thumbs],
                loop: true,
                slidesPerView: 'auto',
                thumbs: {
                  swiper: $sliderThumbnail
                },
              });

              const $nextEl = $swiper.closest('.slider__swiper')?.querySelector('.swiper-button-next');
              if ($nextEl) {
                $nextEl.addEventListener('click', ($event) => {
                  $slider.slideNext();
                });
              }

              const $prevEl = $swiper.closest('.slider__swiper')?.querySelector('.swiper-button-prev');
              if ($prevEl) {
                $prevEl.addEventListener('click', ($event) => {
                  $slider.slidePrev();
                });
              }
            } else if ($swiper.closest('.slider--instagram')) {
              const $slider = new Swiper($sliderId, {
                modules: [Autoplay],
                loop: true,
                freeMode: true,
                slidesPerView: 'auto',
                speed: 5000,
                autoplay: {
                  delay: 0,
                },
                on: {
                  slideChangeTransitionStart: function () {
                    const $target = $swiper.querySelector<HTMLElement>('.swiper-wrapper');
                    if ($target) {
                      $target.style.transitionTimingFunction = 'linear';
                    }
                  }
                },
              });
            } else {
              const $slider = new Swiper($sliderId, {
                modules: [Navigation, Pagination, Scrollbar],
                loop: true,
                slidesPerView: 'auto',

                scrollbar: {
                  el: '.swiper-scrollbar',
                  draggable: true,
                },

                pagination: {
                  el: '.swiper-pagination',
                  type: 'bullets',
                  clickable: true,
                },

                navigation: {
                  nextEl: '.swiper-button-next',
                  prevEl: '.swiper-button-prev',
                },
              });

              const $nextEl = $swiper.closest('.slider__swiper')?.querySelector('.swiper-button-next');
              if ($nextEl) {
                $nextEl.addEventListener('click', ($event) => {
                  $slider.slideNext();
                });
              }

              const $prevEl = $swiper.closest('.slider__swiper')?.querySelector('.swiper-button-prev');
              if ($prevEl) {
                $prevEl.addEventListener('click', ($event) => {
                  $slider.slidePrev();
                });
              }
            }
          }
        });
      }
    }
  }
}

